module.exports = __webpack_public_path__ + "img/gb9113_3.prt.e70cbf09.jpg";